import Layout from '@/layout'
import _import from './loader.js'

export function routerTrans (asyncRouterMap) {
  
  const accessedRouters = asyncRouterMap.filter(route => {
    if (route.component) {
      // route.redirect = ''
      route.isShow = true
      if (route.menuType == 5) {
        route.isShow = false
        route.title = "首页"
      }
      if (route.component == 'Layout') {
        route.component = Layout
      }else if(route.component.indexOf("http")>-1){
        route.component = Layout
      } else {
        route.component = _import(route.component)
      }
    }
    if (route.children && route.children.length) {
      route.children = routerTrans(route.children)
    } else {
      route.children = []
    }
    return true
  })
  return accessedRouters
}
// export function routerRedirect(list) {
//   // if (list === undefined || list == null) {
//   //   list = []
//   // }
//   // console.log(list)
//   // list.push(operationRouter())
//   // list.push(notFundRouter())
//   return JSON.stringify(list)
//   // return JSON.stringify(listRouter)
// }

export function getViews (path) {
  return resolve => require(['@/views/' + path + '.vue'], resolve)
}
